import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './ProjectsGallery.css';

const ProjectsGallery = ({ projects }) => {
    const [selectedProject, setSelectedProject] = useState(null);
    const [filter, setFilter] = useState('all');

    const filteredProjects = filter === 'all' 
        ? projects 
        : projects.filter(project => project.category === filter);

    const categories = ['all', ...new Set(projects.map(project => project.category))];

    return (
        <div className="projects-gallery">
            <motion.div 
                className="filter-container"
                initial={{ y: -50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5 }}
            >
                {categories.map(category => (
                    <motion.button
                        key={category}
                        className={`filter-button ${filter === category ? 'active' : ''}`}
                        onClick={() => setFilter(category)}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        {category.charAt(0).toUpperCase() + category.slice(1)}
                    </motion.button>
                ))}
            </motion.div>

            <motion.div 
                className="projects-grid"
                layout
            >
                <AnimatePresence>
                    {filteredProjects.map(project => (
                        <motion.div
                            key={project.id}
                            className="project-card"
                            layoutId={`project-${project.id}`}
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0, scale: 0.8 }}
                            whileHover={{ scale: 1.05 }}
                            onClick={() => setSelectedProject(project)}
                        >
                            <motion.img 
                                src={project.image} 
                                alt={project.title}
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ delay: 0.2 }}
                            />
                            <motion.div className="project-info">
                                <h3>{project.title}</h3>
                                <p>{project.shortDescription}</p>
                                <div className="project-tags">
                                    {project.technologies.map(tech => (
                                        <span key={tech} className="tag">{tech}</span>
                                    ))}
                                </div>
                            </motion.div>
                        </motion.div>
                    ))}
                </AnimatePresence>
            </motion.div>

            <AnimatePresence>
                {selectedProject && (
                    <motion.div 
                        className="project-modal-backdrop"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={() => setSelectedProject(null)}
                    >
                        <motion.div 
                            className="project-modal"
                            layoutId={`project-${selectedProject.id}`}
                            onClick={e => e.stopPropagation()}
                        >
                            <motion.img 
                                src={selectedProject.image} 
                                alt={selectedProject.title}
                            />
                            <motion.div className="project-modal-content">
                                <h2>{selectedProject.title}</h2>
                                <p>{selectedProject.fullDescription}</p>
                                <div className="project-links">
                                    {selectedProject.demoLink && (
                                        <a 
                                            href={selectedProject.demoLink} 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            className="project-link demo"
                                        >
                                            Live Demo
                                        </a>
                                    )}
                                    {selectedProject.githubLink && (
                                        <a 
                                            href={selectedProject.githubLink} 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            className="project-link github"
                                        >
                                            GitHub
                                        </a>
                                    )}
                                </div>
                                <div className="project-tags">
                                    {selectedProject.technologies.map(tech => (
                                        <span key={tech} className="tag">{tech}</span>
                                    ))}
                                </div>
                            </motion.div>
                            <button 
                                className="close-button"
                                onClick={() => setSelectedProject(null)}
                            >
                                ×
                            </button>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default ProjectsGallery; 